import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  Event as EventIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendingIcon,
  Group as GroupIcon,
  School as SchoolIcon,
  Assessment as AssessmentIcon,
  Public as PublicIcon
} from '@mui/icons-material';

function MoisStatistique2025() {
  const primaryColor = '#E30613';
  const secondaryColor = '#008D36';
  const backgroundColor = '#f5f5f5';

  const activities = [
    {
      date: "20 octobre 2025",
      title: "Lancement officiel du 14ème MSB et célébration de la 4ème Journée Mondiale de la Statistique",
      description: "Cérémonie d'ouverture sous le Haut Patronage du Cabinet de la Primature"
    },
    {
      date: "20-29 octobre 2025",
      title: "Formation du personnel de terrain - Enquête Nationale Agricole Rénovée (ENArB)",
      description: "Renforcement des capacités techniques pour la collecte des données agricoles"
    },
    {
      date: "27-31 octobre 2025",
      title: "Atelier de validation des méthodologies harmonisées de la Communauté Est Africaine",
      description: "Statistiques des prix, monétaires, solidités financières, finances publiques et secteur extérieur"
    },
    {
      date: "28 octobre 2025",
      title: "Réunion du Groupe Sectoriel Statistique (GSS)",
      description: "Coordination des activités statistiques nationales"
    },
    {
      date: "03-08 novembre 2025",
      title: "Atelier national sur l'analyse et production des statistiques de l'état civil",
      description: "Amélioration du système d'enregistrement des faits d'état civil"
    },
    {
      date: "06-07 novembre 2025",
      title: "Premier Congrès des Étudiants en Statistique",
      description: "Organisé par le Club Statistique de l'Université du Lac Tanganyika"
    },
    {
      date: "10-14 novembre 2025",
      title: "Atelier national sur la communication des statistiques de l'état civil",
      description: "Optimisation de la diffusion des données d'état civil"
    },
    {
      date: "11-14 novembre 2025",
      title: "Formation sur le calcul des indicateurs de suivi Vision 2040-2060, PND et ODD",
      description: "Renforcement des capacités en monitoring des agendas de développement"
    },
    {
      date: "18 novembre 2025",
      title: "Célébration de la 33ème Journée Africaine de la Statistique",
      description: "Sous le thème: 'Tirer parti des innovations en matière de données et de statistiques afin de promouvoir une société juste, pacifique, inclusive et prospère pour les Africains'"
    },
    {
      date: "19 novembre 2025",
      title: "Café Statistique - Couplage RGPH/RGAE",
      description: "Retours d'expérience du RGPHAE 2024 et perspectives"
    },
    {
      date: "20 novembre 2025",
      title: "Cérémonie de clôture et présentation des résultats",
      description: "Synthèse des activités et présentation des réalisations statistiques"
    }
  ];

  const productions = [
    "Indice National des Prix à la Consommation (INPCB) - Octobre 2025",
    "Indice des Prix à la Production Agricole (IPPAB) - Octobre 2025",
    "Indice du Coût de la Construction (ICCB) - Octobre 2025",
    "Indice du Chiffre d'Affaires (ICAB) - 3ème trimestre 2025",
    "Indice Harmonisé de la Production Industrielle (IHPI) - 3ème trimestre 2025",
    "Indice du Commerce Extérieur (ICEB) - 3ème trimestre 2025",
    "Traitement et analyse des données du RGPHAE (18 thèmes)",
    "Collecte du Module Agricole de Base Détaillé (MABD) - Octobre 2025 à Mars 2026",
    "Enquête Nationale Agricole Rénovée (ENArB) - Novembre 2025 à Septembre 2026"
  ];

  return (
    <div style={{ backgroundColor: backgroundColor, paddingBottom: '40px', minHeight: '100vh' }}>
      <NavigationBar />
      
      <Container maxWidth="lg" style={{ paddingTop: '50px', marginBottom: '40px' }}>
        
        {/* En-tête principale */}
        <Box textAlign="center" mb={4} pt={4}>
          <Chip 
            label="14ème Édition" 
            style={{ 
              backgroundColor: primaryColor, 
              color: 'white', 
              fontWeight: 'bold',
              marginBottom: '20px',
              fontSize: '1rem',
              padding: '10px 15px'
            }} 
          />
          <Typography 
            variant="h6" 
            component="h5" 
            gutterBottom 
            style={{ 
              fontWeight: 'bold',
              marginBottom: '10px'
            }}
          >
            MOIS DE LA STATISTIQUE AU BURUNDI, EDITION 2025
          </Typography>
          <Typography 
            variant="h6" 
            component="h3" 
            style={{ 
              color: secondaryColor,
              marginBottom: '10px'
            }}
          >
            Du 20 Octobre au 20 Novembre 2025
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap" mt={2}>
            <Chip 
              icon={<EventIcon />} 
              label="4ème Journée Mondiale de la Statistique - 20 Octobre" 
              variant="outlined"
              style={{ borderColor: primaryColor, color: primaryColor }}
            />
            <Chip 
              icon={<EventIcon />} 
              label="33ème Journée Africaine de la Statistique - 18 Novembre" 
              variant="outlined"
              style={{ borderColor: secondaryColor, color: secondaryColor }}
            />
          </Box>
        </Box>

        {/* Thème principal */}
        <Paper elevation={3} style={{ padding: '30px', marginBottom: '30px', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
          <Typography 
            variant="h6" 
            align="center" 
            style={{ 
              color: primaryColor,
              fontStyle: 'italic',
              fontWeight: 'bold',
              lineHeight: '1.2'
            }}
          >
            « INNOVATIONS ET STATISTIQUES DE QUALITÉ : 
            <Box component="span" style={{ color: secondaryColor }}>
              {" "}LEVIERS INCONTOURNABLES POUR L'ATTEINTE DE LA VISION DU BURUNDI, 
              PAYS ÉMERGENT EN 2040 ET PAYS DÉVELOPPÉ EN 2060 »
            </Box>
          </Typography>
        </Paper>

        {/* Introduction et contexte */}
        <Grid container spacing={2} mb={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} style={{ padding: '25px', height: '100%' }}>
              <Typography variant="h6" gutterBottom style={{ color: secondaryColor, display: 'flex', alignItems: 'center' }}>
                <CalendarIcon style={{ marginRight: '10px' }} />
                Contexte Historique
              </Typography>
              <Typography variant="body2" paragraph>
                Le Mois de la statistique au Burundi (MSB) a été recommandé et initié par le Conseil National 
                de l'Information Statistique (CNIS) lors de sa 3ème Session du 14 juin 2012.
              </Typography>
              <Typography variant="body2" paragraph>
                Il est célébré dans la période incluant les Journées Mondiale (20 octobre) et Africaine 
                (18 novembre) de la Statistique, couvrant ainsi la période du 20 octobre au 20 novembre 
                de chaque année depuis 2012.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} style={{ padding: '25px', height: '100%' }}>
              <Typography variant="h6" gutterBottom style={{ color: secondaryColor, display: 'flex', alignItems: 'center' }}>
                <TrendingIcon style={{ marginRight: '10px' }} />
                Vision Stratégique
              </Typography>
              <Typography variant="body2" paragraph>
                Cette 14ème édition se focalise sur la promotion des innovations et des statistiques de qualité, 
                gage et miroir de la bonne gouvernance et du développement durable.
              </Typography>
              <Typography variant="body2">
                Elle vise à soutenir l'émergence du Burundi à l'horizon 2040 et son développement en 2060.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Thèmes internationaux */}
        <Box mb={6}>
          <Typography variant="h6" gutterBottom style={{ color: primaryColor, textAlign: 'center', marginBottom: '30px' }}>
            Thèmes Internationaux 2025
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Card style={{ borderTop: `4px solid ${primaryColor}`, height: '100%' }}>
                <CardContent style={{ textAlign: 'center' }}>
                  <PublicIcon style={{ fontSize: 40, color: primaryColor, marginBottom: '15px' }} />
                  <Typography variant="h6" gutterBottom style={{ color: primaryColor }}>
                    Journée Mondiale
                  </Typography>
                  <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                    « Favoriser le changement grâce à des statistiques et des données de qualité pour tous »
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card style={{ borderTop: `4px solid ${secondaryColor}`, height: '100%' }}>
                <CardContent style={{ textAlign: 'center' }}>
                  <AssessmentIcon style={{ fontSize: 40, color: secondaryColor, marginBottom: '15px' }} />
                  <Typography variant="h6" gutterBottom style={{ color: secondaryColor }}>
                    Journée Africaine
                  </Typography>
                  <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                    « Tirer parti des innovations en matière de données et de statistiques afin de promouvoir 
                    une société juste, pacifique, inclusive et prospère pour les Africains »
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card style={{ borderTop: `4px solid #1976d2`, height: '100%' }}>
                <CardContent style={{ textAlign: 'center' }}>
                  <GroupIcon style={{ fontSize: 40, color: '#1976d2', marginBottom: '15px' }} />
                  <Typography variant="h6" gutterBottom style={{ color: '#1976d2' }}>
                    Union Africaine
                  </Typography>
                  <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                    « Justice Pour les africains et les personnes d'ascendance africaine à travers les réparations »
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* Programme des activités */}
        <Box mb={6}>
          <Typography variant="h6" gutterBottom style={{ color: secondaryColor, marginBottom: '30px' }}>
            <EventIcon style={{ marginRight: '15px', verticalAlign: 'bottom' }} />
            Programme des Activités
          </Typography>
          <Grid container spacing={2}>
            {activities.map((activity, index) => (
              <Grid item xs={12} key={index}>
                <Card 
                  variant="outlined"
                  style={{ 
                    transition: 'all 0.3s ease',
                    borderLeft: `4px solid ${index % 2 === 0 ? primaryColor : secondaryColor}`
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateX(5px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateX(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <CardContent style={{ padding: '20px' }}>
                    <Box display="flex" alignItems="center" mb={1}>
                      <Chip 
                        label={activity.date} 
                        size="small" 
                        style={{ 
                          backgroundColor: index % 2 === 0 ? primaryColor : secondaryColor,
                          color: 'white',
                          fontWeight: 'bold',
                          marginRight: '15px'
                        }} 
                      />
                    </Box>
                    <Typography variant="h6" style={{ color: '#333', marginBottom: '5px' }}>
                      {activity.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {activity.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Productions statistiques */}
        <Box mb={6}>
          <Typography variant="h6" gutterBottom style={{ color: primaryColor, marginBottom: '20px' }}>
            <AssessmentIcon style={{ marginRight: '15px', verticalAlign: 'bottom' }} />
            Productions Statistiques Pendant le MSB 2025
          </Typography>
          <Paper elevation={2} style={{ padding: '25px' }}>
            <List>
              {productions.map((production, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <SchoolIcon style={{ color: secondaryColor }} />
                  </ListItemIcon>
                  <ListItemText primary={production} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Box>

        {/* Présentations de clôture */}
        <Box mb={6}>
          <Typography variant="h5" gutterBottom style={{ color: secondaryColor, marginBottom: '20px' }}>
            Présentations de Clôture - 20 Novembre 2025
          </Typography>
          <Grid container spacing={2}>
            {[
              "Rôle des comptes de l'environnement (SCEE) dans la Vision 2040-2060",
              "Démonstration de navigation sur le site web de l'INSBU",
              "Rapport Open Data Inventory (ODIN)",
              "Résultats des modules agricoles du RGPHAE",
              "Synergies institutionnelles et partenariats stratégiques"
            ].map((item, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Paper style={{ padding: '15px', backgroundColor: '#f8f9fa' }}>
                  <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                    <Box 
                      component="span" 
                      style={{ 
                        backgroundColor: primaryColor,
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '10px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold'
                      }}
                    >
                      {index + 1}
                    </Box>
                    {item}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Appel à participation */}
        <Paper 
          elevation={2} 
          style={{ 
            padding: '30px', 
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
            color: 'white',
            textAlign: 'center'
          }}
        >
          <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold' }}>
            APPEL À PARTICIPATION
          </Typography>
          <Typography variant="body2" paragraph style={{ fontSize: '1.1rem' }}>
            Tout partenaire et ami du Système Statistique National du Burundi est invité à soutenir 
            et à s'associer aux différentes composantes dans la commémoration des activités du 
            14ème Mois de la Statistique au Burundi.
          </Typography>
          <Typography variant="h6" style={{ fontStyle: 'italic' }}>
            Ensemble, innovons et marchons avec des statistiques de qualité pour soutenir 
            l'émergence et le développement du Burundi.
          </Typography>
        </Paper>

      </Container>
      
      <Footer />
    </div>
  );
}

export default MoisStatistique2025;